import { render, staticRenderFns } from "./MappedValueColumn.vue?vue&type=template&id=32887310&scoped=true&"
import script from "./MappedValueColumn.vue?vue&type=script&lang=ts&"
export * from "./MappedValueColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32887310",
  null
  
)

export default component.exports